import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const LoginPage = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const redirectTo = new URLSearchParams(location.search).get("next") || "/account";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    const res = await login(email.trim(), password);
    setLoading(false);
    if (res.ok) {
      nav(res.user?.role === "admin" ? "/admin" : redirectTo, { replace: true });
    } else {
      setErr(res.error || "Login failed.");
    }
  };

  return (
    <div className="px-4 md:px-8 py-12 md:py-20 min-h-[70vh]" data-testid="login-page">
      <div className="max-w-md mx-auto border-4 border-[#1C1914] bg-[#FFFDF5] shadow-hard p-6 md:p-10">
        <p className="font-condensed text-sm uppercase tracking-widest text-[#D95D39]">// log in</p>
        <h1 className="font-display text-4xl md:text-5xl uppercase leading-none mt-2">
          Welcome back, regret-haver.
        </h1>
        <p className="font-body text-base mt-3 text-[#1C1914]/80">
          Check your orders, track your shipments, regret your purchases.
        </p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="block font-condensed text-xs uppercase tracking-widest text-[#1C1914]/70 mb-1">Email</label>
            <input
              type="email"
              required
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-duds"
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="block font-condensed text-xs uppercase tracking-widest text-[#1C1914]/70 mb-1">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-duds"
              data-testid="login-password"
            />
          </div>
          {err && (
            <div className="border-2 border-[#D95D39] bg-[#D95D39]/10 px-3 py-2 font-condensed text-sm uppercase tracking-widest text-[#D95D39]" data-testid="login-error">
              {err}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="btn-duds w-full flex items-center justify-center gap-2"
            data-testid="login-submit"
          >
            {loading && <Loader2 size={16} className="animate-spin" />}
            Log in
          </button>
        </form>

        <div className="flex items-center justify-between mt-6 font-condensed text-xs uppercase tracking-widest">
          <Link to="/forgot-password" className="text-[#1C1914]/70 hover:text-[#D95D39]" data-testid="login-forgot-link">
            Forgot password?
          </Link>
          <Link to="/register" className="text-[#1C1914]/70 hover:text-[#D95D39]" data-testid="login-register-link">
            Make an account →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
